import { Modal } from "bootstrap";

const initProfilePage = () => {
    const profilePage =
        document.querySelector(
            ".profile-page"
        );

    if (!profilePage) {
        return;
    }
    initProfileSharing();
    initGuestQueueWidgetTheme();
};

/* =========================================================
   GuestQueue Widget Theme
   ========================================================= */

const initGuestQueueWidgetTheme = () => {
    const root =
        document.documentElement;

    const widgetScript =
        document.querySelector(
            "script[data-guestqueue-widget]"
        );

    if (!widgetScript) {
        return;
    }

    const getParentTheme = () => {
        return root.getAttribute(
            "data-bs-theme"
        ) === "dark"
            ? "dark"
            : "light";
    };

    const updateWidgetTheme = () => {
        const parentTheme =
            getParentTheme();

        const widgetTheme =
            widgetScript.dataset.theme;

        /*
         * Only update the widget when
         * the themes don't match.
         */
        if (
            widgetTheme !==
            parentTheme
        ) {
            widgetScript.dataset.theme =
                parentTheme;
        }
    };


    /* =====================================================
       Sync Initial Theme
       ===================================================== */

    updateWidgetTheme();


    /* =====================================================
       Watch Parent Theme
       ===================================================== */

    const observer =
        new MutationObserver(
            updateWidgetTheme
        );

    observer.observe(
        root,
        {
            attributes: true,
            attributeFilter: [
                "data-bs-theme"
            ],
        }
    );
};
const initProfileSharing = () => {
    const shareButton =
        document.querySelector(
            "#profileShareButton"
        );

    if (!shareButton) {
        return;
    }


    const pageUrl =
        window.location.href;


    const pageTitle =
        shareButton.dataset.sharetitle ||
        document.title;

    const pageText =
        shareButton.dataset.sharetext ||
        "";


    /* =====================================================
       Configure Modal Share Links
       ===================================================== */

    const encodedUrl =
        encodeURIComponent(
            pageUrl
        );


    const encodedTitle =
        encodeURIComponent(
            pageTitle
        );

     const encodedText =
        encodeURIComponent(
            pageText
        );

    document
        .querySelectorAll(
            "[data-share]"
        )
        .forEach((button) => {

            switch (
                button.dataset.share
            ) {

                case "facebook":

                    button.href =
                        "https://www.facebook.com/" +
                        "sharer/sharer.php?u=" +                        
                        encodedUrl +
                        encodeURIComponent('?mtm_campaign=share&mtm_source=facebook'); 

                    break;


                case "twitter":

                    button.href =
                        "https://twitter.com/" +
                        "intent/tweet?url=" +
                        encodedUrl + 
                        encodeURIComponent('?mtm_campaign=share&mtm_source=twitter') +
                        "&text=" +
                        encodedText + ' @GuestQueue';

                    break;


                case "linkedin":

                    button.href =
                        "https://www.linkedin.com/" +
                        "sharing/share-offsite/" +
                        "?url=" +
                        encodedUrl + 
                        encodeURIComponent('?mtm_campaign=share&mtm_source=linkedin');

                    break;


                case "whatsapp":

                    button.href =
                        "https://wa.me/?text=" +
                        encodedText +
                        "%20" +
                        encodedUrl + 
                        encodeURIComponent('?mtm_campaign=share&mtm_source=whatsapp');

                    break;


                case "email":

                    button.href =
                        "mailto:?subject=" +
                        encodedText +
                        "&body=" +
                        encodedUrl + 
                        encodeURIComponent('?mtm_campaign=share&mtm_source=email');;

                    break;

            }

        });


    /* =====================================================
       Share Button
       ===================================================== */

    shareButton.addEventListener(
        "click",
        async () => {

            const isMobile =
                window.matchMedia(
                    "(max-width: 767.98px)"
                ).matches;


            /*
             * Mobile:
             * use native device share tray.
             */
            if (
                isMobile &&
                navigator.share
            ) {

                try {

                    await navigator.share({
                        title: pageTitle,
                        text: pageText,
                        url: pageUrl,
                    });
                    
                    if (typeof window._paq !== "undefined") {
                         window._paq.push(['trackEvent', 'share-click', 'share-tray']);
                    }
                    return;

                } catch (error) {

                    /*
                     * User closed share tray.
                     */
                    if (
                        error.name ===
                        "AbortError"
                    ) {
                        return;
                    }

                }

            }

            if (typeof window._paq !== "undefined") {
                window._paq.push(['trackEvent', 'share-click', 'modal']);
            }
            /*
             * Desktop OR mobile fallback.
             */
            openProfileShareModal();

        }
    );


    initProfileCopyLink();
};

const initProfileCopyLink = () => {
    document
        .querySelectorAll(
            ".profile-copy-link"
        )
        .forEach((button) => {

            button.addEventListener(
                "click",
                async () => {

                    const wrapper =
                        button.closest(
                            ".profile-share-copy"
                        );


                    const input =
                        wrapper?.querySelector(
                            ".profile-share-url"
                        );


                    if (!input) {
                        return;
                    }


                    const label =
                        button.querySelector(
                            "span"
                        );


                    const icon =
                        button.querySelector(
                            "i"
                        );


                    const copyLabel =
                        button.dataset.copyLabel ||
                        "Copy";


                    const copiedLabel =
                        button.dataset.copiedLabel ||
                        "Copied!";


                    try {

                        await navigator.clipboard
                            .writeText(
                                input.value
                            );

                    } catch {

                        input.focus();
                        input.select();

                        document.execCommand(
                            "copy"
                        );

                    }


                    if (label) {
                        label.textContent =
                            copiedLabel;
                    }


                    if (icon) {
                        icon.className =
                            "bi bi-check-lg me-2";
                    }


                    window.setTimeout(
                        () => {

                            if (label) {
                                label.textContent =
                                    copyLabel;
                            }


                            if (icon) {
                                icon.className =
                                    "bi bi-copy me-2";
                            }

                        },
                        2000
                    );

                }
            );

        });
};

const openProfileShareModal = () => {
    const modalElement =
        document.querySelector(
            "#profileShareModal"
        );

    if (!modalElement) {
        return;
    }

    const modal =
        Modal.getOrCreateInstance(
            modalElement
        );

    modal.show();
};

/* =========================================================
   Initialize
   ========================================================= */

document.addEventListener(
    "DOMContentLoaded",
    initProfilePage
);